import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

function snakeToCamel(str: string): string {
	return str.replace(/(_\w)/g, (_match, p1) => {
		const [_, letter] = p1;
		return letter.toUpperCase();
	});
}

type AnimationSpeed = 'none' | 'super-fast' | 'fast' | 'moderate' | 'slow';

const DURATION_CLASSES = {
	none: 'duration-[0ms]',
	'super-fast': 'duration-(--duration-super-fast)',
	fast: 'duration-(--duration-fast)',
	moderate: 'duration-(--duration-moderate)',
	slow: 'duration-(--duration-slow)',
} as const;

function getDurationClass(speed: AnimationSpeed) {
	return DURATION_CLASSES[speed];
}

export { cn, getDurationClass, snakeToCamel };

export type { AnimationSpeed };
